import headerNav from '../headerNav/'
import sideBar from '../sideBar/'
// import navTab from '../navTab/'
import contentMain from '../contentWarp'
export default {
  name: "home",
  data() {
    return {
      isFromPlugin: 0
    }
  },
  components:{
    headerNav,
    sideBar,
    // navTab,
    contentMain
  },
  mounted() {
    this.isFromPlugin = this.$store.getters.isFromPlugin
  }
}



// WEBPACK FOOTER //
// ./src/layout/home/home.js